// Shared scanner helpers for function definition/call parsing and line mapping.
// Keeps utility logic out of extraction/expansion modules.

// Detect valid function/local identifier names with optional hyphen groups.
export function isValidFunctionIdentifier(name: string): boolean {
  // Return true when name matches identifier + optional hyphen segments.
  return /^[a-zA-Z_][a-zA-Z0-9_]*(?:-[a-zA-Z0-9_]+)*$/.test(name)
}

// Count 1-based line number at one source index.
export function resolveLineAt(source: string, index: number): number {
  const prefix = source.slice(0, Math.max(0, index))
  // Return line count from newline-separated prefix text.
  return prefix.split('\n').length
}

// Count newline tokens in one source segment.
export function countNewlines(source: string): number {
  let lines = 0
  // Start one newline count for line-preserving replacements.
  for (let index = 0; index < source.length; index += 1) {
    if (source[index] === '\n') {
      lines += 1
    } else {
      // Continue newline scan.
    }
  }

  // Return total newline count in segment.
  return lines
}

// Build whitespace padding that preserves removed segment line count.
export function buildLinePreservingPadding(segment: string): string {
  const lineBreaks = countNewlines(segment)
  // Return empty string when removed segment has no newline.
  if (lineBreaks === 0) {
    // Return empty string for zero-newline segments.
    return ''
  } else {
    // Return newline padding to preserve source line positions.
    return '\n'.repeat(lineBreaks)
  }
}
